import { LOCAL_SERVICE_SLUGS } from "./local";
// Service catalog for the city × service landing-page matrix.
export const SERVICE_PAGES = [
  {
    slug: "garage-door-spring-repair",
    name: "Garage Door Spring Repair",
    short: "Broken torsion & extension spring replacement, done same-day.",
    icon: "Coil",
  },
  {
    slug: "garage-door-opener-repair",
    name: "Garage Door Opener Repair",
    short: "LiftMaster, Chamberlain & Genie opener repair and installation.",
    icon: "Settings",
  },
  {
    slug: "off-track-garage-door-repair",
    name: "Off-Track Door Repair",
    short: "Doors off the track, bent tracks, worn rollers and cables.",
    icon: "AlignHorizontalDistributeCenter",
  },
  {
    slug: "garage-door-panel-replacement",
    name: "Panel Replacement",
    short: "Dented, cracked or rotted panel and section replacement.",
    icon: "LayoutPanelLeft",
  },
  {
    slug: "new-garage-door-installation",
    name: "New Garage Door Installation",
    short: "New steel, insulated, carriage & modern doors installed.",
    icon: "DoorOpen",
  },
  {
    slug: "emergency-garage-door-repair",
    name: "24/7 Emergency Repair",
    short: "Around-the-clock emergency response, same-day on-site.",
    icon: "Siren",
  },
  {
    slug: "garage-door-wont-close-repair",
    name: "Garage Door Won't Close Repair",
    short: "Sensor, limit and reversing fixes so your door closes right.",
    icon: "ShieldAlert",
  },
  {
    slug: "garage-door-cable-repair",
    name: "Garage Door Cable Repair",
    short: "Frayed, snapped or off-the-drum lift cables replaced safely.",
    icon: "Cable",
  },
  {
    slug: "garage-door-roller-replacement",
    name: "Garage Door Roller Replacement",
    short: "Worn, noisy rollers swapped for smooth, quiet long-life ones.",
    icon: "CircleDot",
  },
  {
    slug: "garage-door-remote-programming",
    name: "Garage Door Remote & Keypad Programming",
    short: "Remotes, keypads and HomeLink programmed and synced.",
    icon: "KeyRound",
  },
];

export const getService = (slug) => SERVICE_PAGES.find((s) => s.slug === slug);

// Only these services have individually written city pages (see data/local).
export const LOCAL_SERVICES = SERVICE_PAGES.filter((s) => LOCAL_SERVICE_SLUGS.includes(s.slug));
